
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#EAEDF2"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M24.406 8.656l3.89 3.938c.423.422.704 1.031.704 1.594V29.75A2.25 2.25 0 0126.75 32h-13.5A2.221 2.221 0 0111 29.75v-19.5A2.25 2.25 0 0113.25 8h9.563c.562 0 1.171.234 1.593.656zm3.013 5.27a.838.838 0 00-.153-.254l-3.938-3.938c-.072-.071-.17-.116-.255-.153L23 9.547V14h4.453l-.034-.073zM26.75 30.5h-13.5a.74.74 0 01-.75-.75v-19.5c0-.375.328-.75.75-.75h8.25v4.875c0 .656.469 1.125 1.125 1.125H27.5v14.25c0 .422-.375.75-.75.75zm-2.813-12c.282 0 .563.281.563.563v.375a.57.57 0 01-.563.562h-7.875a.542.542 0 01-.562-.563v-.375a.57.57 0 01.563-.562h7.875zm.563 3.563c0-.282-.281-.563-.563-.563h-7.875a.57.57 0 00-.562.563v.375c0 .328.234.562.563.562h7.875a.57.57 0 00.562-.563v-.375zm-.563 2.437c.282 0 .563.281.563.563v.375a.57.57 0 01-.563.562h-7.875a.542.542 0 01-.562-.563v-.375a.57.57 0 01.563-.562h7.875z","fill":"#586E8C"}})])
          )
        }
      }
    